import i18n from "i18next";
import i18n_de from "./i18n_de.js";
import i18n_en from "./i18n_en.js";
import i18n_es from "./i18n_es.js";
import i18n_fr from "./i18n_fr.js";
import { initReactI18next } from "react-i18next";

/**
 * How to add a new language:
 * - Copy an existing language file and rename it to match the specific language
 * - Import the new language file here and add it to the i18n_config.resources object below
 *   with the correct language key (de = German, en = English, ...)
 * - Translate all expressions to the right inbetween ""
 * - When translating, please note:
 *     - Do not translate words within {{}}
 *     - Some expressions might contain new lines (\n) or html tags (<b>, <i>, ...)
 *       please keep these in the translation
 */

const i18n_config = {
    lng: "de",
    fallbackLng: ["de", "en", "es", "fr"],
    resources: {
        de: i18n_de,
        en: i18n_en,
        es: i18n_es,
        fr: i18n_fr,
    }
}

const setupI18n = ()=>{
    i18n.use(initReactI18next).init(i18n_config);
}
setupI18n()
export default setupI18n
